import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {

  constructor(public jwtHelper: JwtHelperService, private router: Router,
    private toastrService: ToastrService) { }

  ngOnInit() {
    if (!this.jwtHelper.isTokenExpired()) {
      this.router.navigate(['/access-denied']);
    }
  }
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('capabilities')
    // console.log("token destroyed")
    this.toastrService.success("Logged Out Successfully");
    this.router.navigate(['/login'])
  }
}
